export const strings = {
  required: '{field} gereklidir',
  min_length: '{field} en az {length} karakter olmalıdır',
  max_length: '{field} {length} karakterden uzun olamaz',
};